import { render, staticRenderFns } from "./overdueDetail.vue?vue&type=template&id=95d85184&scoped=true&"
import script from "./overdueDetail.vue?vue&type=script&lang=js&"
export * from "./overdueDetail.vue?vue&type=script&lang=js&"
import style0 from "./overdueDetail.vue?vue&type=style&index=0&id=95d85184&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d85184",
  null
  
)

export default component.exports